// Zod-free so the UI can import it without pulling in the schema layer.

/**
 * Agent catalog groundwork (WI 2050). There is no Accenture agent catalog yet, so
 * a task's `agentMatch` is only the AI's estimate that an agent likely exists.
 * These strings keep the wizard, the dashboard and the client export saying so.
 */
export const GCC_AGENT_ESTIMATE_LABEL = 'Agent (AI estimate)'

/** Catalog sources analysts will choose from once the catalog exists. None is pre-selected. */
export const GCC_PLANNED_AGENT_SOURCES: readonly string[] = ['SAP', 'SynOps', 'AI Refinery', 'Procurement', 'KDP', 'Other']

export const GCC_AGENT_CATALOG_UNAVAILABLE_NOTE =
  'No Accenture agent catalog is available yet, so agent suggestions are AI estimates that have not been checked against a catalog.'

export const GCC_AGENT_CATALOG_SUMMARY = 'Not available yet – AI estimate used'
